export const filterIds = [
	'organization',
	'allocation',
	'status',
	'builder',
	'project',
	'customer',
	'type',
	'requirements',
	'created',
	'creator',
	'target',
	'due',
	'design-completed',
	'difficulty',
	'assignee',
	'owner',
	'sales-person',
] as const;
